import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";

const MarkdownRenderer = ({ markdownText }) => {
  return (
    <ReactMarkdown
      children={markdownText}
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeSanitize]}
      components={{
        h2: ({ node, ...props }) => <h2 className="chat-heading" {...props} />,
        p: ({ node, ...props }) => <p className="chat-paragraph" {...props} />,
        ul: ({ node, ...props }) => <ul className="chat-list" {...props} />,
        ol: ({ node, ...props }) => <ol className="chat-list" {...props} />,
        li: ({ node, ...props }) => (
          <li className="chat-list-item" {...props} />
        ),
        a: ({ node, ...props }) => <a className="chat-link" {...props} />,
        code: ({ node, ...props }) => <code className="chat-code" {...props} />,
        pre: ({ node, ...props }) => <pre className="chat-pre" {...props} />,
      }}
    />
  );
};

export default MarkdownRenderer;
